'use client'

import Link from 'next/link'
import { Home, Mail, ArrowRight } from 'lucide-react'
import { useInView } from '@/hooks/useInView'

export default function NotFound() {
  const { ref, isInView } = useInView()

  return (
    <div className="min-h-screen flex items-center justify-center">
      <section className="section w-full">
        <div ref={ref} className="section-inner text-center">
          <div
            className={`anim-scale-in ${isInView ? 'in-view' : ''} text-[8rem] md:text-[12rem] font-extrabold gradient-text-red leading-none mb-4 select-none`}
          >
            404
          </div>

          <h1
            className={`anim-fade-in-up anim-delay-1 ${isInView ? 'in-view' : ''} text-3xl md:text-4xl font-bold text-white mb-4`}
          >
            Page Not Found
          </h1>

          <p
            className={`anim-fade-in-up anim-delay-2 ${isInView ? 'in-view' : ''} text-lg text-zinc-400 max-w-lg mx-auto mb-4`}
          >
            Looks like this page took a wrong turn at the ridge cap.
          </p>

          <p
            className={`anim-fade-in-up anim-delay-3 ${isInView ? 'in-view' : ''} text-sm text-zinc-400 max-w-md mx-auto mb-10`}
          >
            The page you&apos;re looking for doesn&apos;t exist, was moved,
            or maybe it&apos;s up on the roof somewhere. Let&apos;s get you
            back on solid ground.
          </p>

          <div
            className={`anim-fade-in-up anim-delay-4 ${isInView ? 'in-view' : ''} flex items-center justify-center gap-4 flex-wrap`}
          >
            <Link href="/" className="btn-primary glow-red-sm">
              <Home size={18} />
              Back to Home
            </Link>
            <Link href="/contact" className="btn-ghost">
              <Mail size={18} />
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}
